module.exports = __webpack_public_path__ + "media/42.9d05c9d9.mp3";